import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiLogoComponent } from '../ui-logo/ui-logo.component';

/**
 * The product lockup: the app mark, and beside it the wordmark — "Turn" in the
 * theme foreground, "Up" in the brand purple gradient, closed by a green rising
 * arrow that echoes the check in the mark. Both are drawn at every width; the
 * lockup fits a 320px phone, so nothing is dropped on the way down.
 *
 * The size follows the host's font-size — the mark is a fixed multiple of it —
 * so each call site picks one with a text utility, as the shells do with
 * `<ui-brand class="text-3xl" />`.
 */
@Component({
  selector: 'ui-brand',
  imports: [UiLogoComponent],
  standalone: true,
  templateUrl: './ui-brand.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'img',
    // The lockup is a drawing, not a line of prose: leading would only pad it
    // out. Kept on the host so the shape does not change with the text utility
    // a call site happens to pick.
    class: 'leading-none',
    '[attr.aria-label]': 'label',
  }
})
export class UiBrandComponent {
  /** Spoken name — the styled words below are hidden from assistive tech. */
  readonly label = 'Turn Up';
}
